"use client"

import { createPortal } from "react-dom"

type AnnotationStroke = {
  id: string
  points: { x: number; y: number }[]
  color: string
  width: number
  createdAt: number
}

export function AnnotationOverlay({
  strokes,
}: {
  strokes: AnnotationStroke[]
}) {
  if (strokes.length === 0) return null

  return createPortal(
    <svg
      data-meridial-ui
      className="pointer-events-none fixed inset-0 z-[999998] h-full w-full"
      viewBox="0 0 1 1"
      preserveAspectRatio="none"
    >
      {strokes.map((stroke) => (
        <polyline
          key={stroke.id}
          points={stroke.points
            .map((point) => `${point.x},${point.y}`)
            .join(" ")}
          fill="none"
          stroke={stroke.color}
          strokeWidth={stroke.width / 1000}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      ))}
    </svg>,
    document.body
  )
}
